module.exports = __webpack_public_path__ + "img/about8.d1d2a27e.png";